export { default } from './attachment-item';
